import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppTheme } from '@lds/themes';
import App from './App';
import { loadConfig } from './config';
import { theme } from './styles/theme';
import '@lds/themes/styles/global.css';

async function bootstrap() {
  await loadConfig();

  // Aplica o tema LDS (Localiza) antes de renderizar.
  AppTheme.apply(theme);

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

bootstrap();
